import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { target: String }

  connect() {}

  open() {
    const modal = document.getElementById(this.targetValue)
    if (modal) {
      modal.showModal()
    } else {
      console.error('Modal not found:', this.targetValue)
    }
  }
}
